import AsyncStorage from '@react-native-async-storage/async-storage';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';

const notificationsStorage = createJSONStorage<Array<string>>(() => AsyncStorage);
export const readNotificationsStorage = atomWithStorage('readNotifications', [''], notificationsStorage);
